import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environments';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SummaryService {
  constructor(
    private http: HttpClient,
    private errorService: ErrorService
  ) { }

  // Not school-year scoped: the summary reports each section's latest activity.
  getEoPSummary(buildingId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.eopSummary.replace(':buildingId', buildingId);

    return this.http.get<{has_error: boolean, message: string, data: any}>(url).pipe(
        catchError(this.errorService.handleError)
    );
  }
}